import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "payments-block__middle replenishment-qr" }
const _hoisted_2 = {
  key: 0,
  class: "replenishment-qr__waiting"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "replenishment-qr__waiting-text" }
const _hoisted_5 = { class: "replenishment-qr__qr" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "replenishment-qr__alt" }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isManualSbpQrWaiting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "replenishment-qr__spinner",
            src: require('@/assets/img/90-ring-with-bg.svg'),
            alt: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('invoice.manual-sbp-qr-waiting')), 1)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              style: {"max-width":"300px"},
              class: "qr-code",
              src: _ctx.qrCodeImageSrc
            }, null, 8, _hoisted_6)
          ]),
          (_ctx.sbpOpenUrl)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('invoice.or-text')), 1),
                _createElementVNode("a", {
                  target: "_blank",
                  href: _ctx.sbpOpenUrl,
                  class: "replenishment-qr__link"
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('invoice.continue-with-link-text')), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("svg", {
                    width: "17",
                    height: "17",
                    viewBox: "0 0 17 17",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M3.89998 4.89995C3.74085 4.89995 3.58823 4.96317 3.47571 5.07569C3.36319 5.18821 3.29998 5.34082 3.29998 5.49995V12.3C3.29998 12.6312 3.56878 12.9 3.89998 12.9H10.7C10.8591 12.9 11.0117 12.8367 11.1242 12.7242C11.2368 12.6117 11.3 12.4591 11.3 12.3V9.09995C11.3 8.94082 11.3632 8.78821 11.4757 8.67569C11.5882 8.56317 11.7408 8.49995 11.9 8.49995C12.0591 8.49995 12.2117 8.56317 12.3242 8.67569C12.4368 8.78821 12.5 8.94082 12.5 9.09995V12.3C12.5 12.7773 12.3103 13.2352 11.9728 13.5727C11.6352 13.9103 11.1774 14.1 10.7 14.1H3.89998C3.42259 14.1 2.96475 13.9103 2.62718 13.5727C2.28962 13.2352 2.09998 12.7773 2.09998 12.3V5.49995C2.09998 5.02256 2.28962 4.56472 2.62718 4.22716C2.96475 3.88959 3.42259 3.69995 3.89998 3.69995H7.89998C8.05911 3.69995 8.21172 3.76317 8.32424 3.87569C8.43676 3.98821 8.49998 4.14082 8.49998 4.29995C8.49998 4.45908 8.43676 4.61169 8.32424 4.72422C8.21172 4.83674 8.05911 4.89995 7.89998 4.89995H3.89998Z"
                    }),
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M5.45514 10.7025C5.508 10.761 5.57189 10.8085 5.64313 10.8423C5.71438 10.8761 5.79159 10.8955 5.87035 10.8995C5.9491 10.9034 6.02787 10.8918 6.10213 10.8653C6.17639 10.8387 6.24469 10.7978 6.30314 10.7449L13.6999 4.0521V6.3001C13.6999 6.45923 13.7631 6.61184 13.8757 6.72436C13.9882 6.83688 14.1408 6.9001 14.2999 6.9001C14.4591 6.9001 14.6117 6.83688 14.7242 6.72436C14.8367 6.61184 14.8999 6.45923 14.8999 6.3001V2.7001C14.8999 2.54097 14.8367 2.38836 14.7242 2.27583C14.6117 2.16331 14.4591 2.1001 14.2999 2.1001H10.6999C10.5408 2.1001 10.3882 2.16331 10.2757 2.27583C10.1631 2.38836 10.0999 2.54097 10.0999 2.7001C10.0999 2.85923 10.1631 3.01184 10.2757 3.12436C10.3882 3.23688 10.5408 3.3001 10.6999 3.3001H12.7423L5.49754 9.8553C5.43903 9.90817 5.39151 9.97205 5.35772 10.0433C5.32392 10.1145 5.30449 10.1918 5.30055 10.2705C5.29662 10.3493 5.30824 10.428 5.33477 10.5023C5.36129 10.5766 5.40219 10.6441 5.45514 10.7025Z"
                    })
                  ], -1))
                ], 8, _hoisted_8)
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}